import type { Testimonial } from '@/schemas/components/molecules/testimonialSchema';

interface TestimonialCardProps {
  className?: string;
  testimonial: Testimonial;
}

export const TestimonialCard = ({
  className,
  testimonial: { authorName, authorImage, authorTitle, testimonialText },
}: TestimonialCardProps) => (
  <div
    className={`flex flex-col items-center justify-center gap-6 ${className}`}
  >
    <h2 className="w-full px-2 text-center">
      <blockquote dangerouslySetInnerHTML={{ __html: testimonialText }} />
    </h2>
    <div className="flex flex-col items-center justify-center">
      {authorImage && (
        <img
          src={authorImage.url}
          alt={authorImage?.alternativeText ?? ''}
          className="border-brand-purple-bright mb-2 max-h-12 max-w-12 rounded-full border p-[1px]"
        />
      )}
      <span className="text-base font-medium text-white">{authorName}</span>
      <p className="text-sm text-white">{authorTitle}</p>
    </div>
  </div>
);
